export function asParams(obj: {[key: string]: any}) {
  return Object.keys(obj).map(key => `${key}=${encodeURIComponent(obj[key])}`).join('&')
}

export function linkFullPath(link: HTMLAnchorElement) {
  return `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`
}

export function getParameterByName(name: string) {
  const url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)

  if (!results) { return null }
  if (!results[2]) { return '' }
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function get(
    url: string,
    params = {},
    onSuccess = (response: any) => {return},
    onFailure = () => { return }
  ) {
  const request = new XMLHttpRequest()
  request.open('GET', `${url}?${encodeParams(params)}`, true)

  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText)
      onSuccess(data)
    } else {
      console.error(`Error: ${request.status}`)
      onFailure()
    }
  }
  request.onerror = () => {
    onFailure()
  }
  request.send()
}

export function post(url: string, params: {}, callback?: () => void) {
  const xhr = new XMLHttpRequest()
  xhr.open('POST', url, true)
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  xhr.onload = () => {
    if (xhr.status !== 200) {
      console.error('Request failed. Returned status of ' + xhr.status)
    }
    if (callback) { callback() }
  }
  xhr.onerror = () => {
    console.error('Request errored. Returned status of ' + xhr.status)
    if (callback) { callback() }
  }
  xhr.send(encodeParams(params))
}

export function encodeParams(object: {[key: string]: boolean | string | number | null }) {
  let encodedString = ''
  for (const prop in object) {
    if (object.hasOwnProperty(prop)) {
      if (encodedString.length > 0) {
        encodedString += '&'
      }
      encodedString += encodeURI(`${prop}=${object[prop]}`)
    }
  }
  return encodedString
}

interface DownloadAnalytics {
  fileURL: string
  sourceURL: string
  referrer: string
}

export function supportedBrowser() {
  return !!document.addEventListener
}

// Executes the provided function when the browser is in a ready state
export function docready(fn: () => void) {
  // Typecast to any to handle IE check
  const doc: any = document
  if (doc.attachEvent ? doc.readyState === 'complete' : doc.readyState !== 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

// Returns the MSIE Version number for the older IEs (<= 11).
// Will return null for Edge.
// https://msdn.microsoft.com/library/cc196988(v=vs.85).aspx
// https://docs.microsoft.com/en-us/internet-explorer/ie11-deploy-guide/deprecated-document-modes
export function olderIEVersion(): number | null {
  return ((window.document as any).documentMode as number)
}

// Are we on the production domain?
export function onProductionDomain() {
  return location.host === 'catalystresearch.io' ||
    location.host === 'www.catalystresearch.io'
}

export function sendGoogleAnalytics() {
  if (!onProductionDomain()) { return }
  const ga: any = (window as any).ga
  if (typeof ga !== 'function') { return }
  ga('set', 'location', location.href.split('#')[0])
  ga('send', 'pageview', { title: document.title })
}
